export default __webpack_public_path__ + "static/media/lomoIcon3-darkComplete.e45e6cba.svg";